import { Injectable } from '@angular/core';
import { AlertController,Platform } from '@ionic/angular';
import { Plugin } from '@capacitor/core';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Http, Headers, RequestOptions } from '@angular/http';
import { ApiService } from '../api/api.service';
import { map } from 'rxjs/operators';

interface AppUpdate{
  current:string;
  enabled:boolean;
  msg?:{
    title:string;
    msg:string;
    btn:string;
  };
  majorMsg?:{
    title:string;
    msg:string;
    btn:string;
  };
  minorMsg?:{
    title:string;
    msg:string;
    btn:string;
  };
}
@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  updateExample = 'https://lsm.com.pk/api/versions_json/v.php?filename=version.json';
  maintenanceExample = 'https://lsm.com.pk/api/versions_json/v.php?filename=maintenance.json';
  constructor(private alertCrtl:AlertController,
    private appVersion:AppVersion,
    private iab:InAppBrowser,
    public http: Http,
    public service:ApiService,
    private plt:Platform) { }

    async checkForUpdate(){
      this.http.get(this.maintenanceExample).pipe(map(res => res.json())).subscribe(async info => {
        if(info.enabled){
          this.presentAlert(info.msg.title,info.msg.msg)
        }
      })
      this.http.get(this.updateExample).pipe(map(res => res.json())).subscribe(async info => {
        console.log(info)
            const versionNumber = await this.appVersion.getVersionNumber()
            if(info.current > versionNumber){
              this.presentAlert(info.majorMsg.title,info.majorMsg.msg,info.majorMsg.btn,info.allowClose)
            }
      })
    }

    opneAppStoreEntry(){
      console.log('Open me')
      if(this.plt.is('android')){
        // this.market.open('com.lsm.app');
        window.open("https://play.google.com/store/apps/details?id=com.lsm.app","_system");
      }else{
        // this.iab.create('itms-app://itunes.apple.com/Lsm Pakistan/id1631159158','_blank')
        window.open("https://apps.apple.com/pk/app/Lsm%20Pakistan/id1631159158","_system");
      }
    }

    async presentAlert(header, message,buttonText= '',allowClose=false){
      const buttons = []
      if(buttonText != ''){
        buttons.push({
          text:buttonText,
          handler: () => {
            this.opneAppStoreEntry()
          }
        })
      }
      if(allowClose){
        buttons.push({
          text:'Close',
          role:'cancel'
        })
      }
      const alert = await this.alertCrtl.create({
        header,
        message,
        buttons,
        backdropDismiss:allowClose,
        mode:'ios'
      });
      await alert.present()
    }
}
